import { acctServerInstance, adminServerInstance } from "../axios/instances";
import { 
    GET_LAST_STATE_STATISTICS,
    GET_LAST_STATE_STATISTICS_SUCCESS,
    GET_LAST_STATE_STATISTICS_FAIL,
    GET_DELIVER_RETURN,
    GET_DELIVER_RETURN_SUCCESS,
    GET_DELIVER_RETURN_FAIL,
    GET_WRONG_ROUTE_ORDERS,
    GET_WRONG_ROUTE_ORDERS_SUCCESS,
    GET_WRONG_ROUTE_ORDERS_FAIL
 } from './types';


export function getDeliverReturn(start_time, end_time, warehouse){
    return function(dispatch){
        dispatch({type: GET_DELIVER_RETURN})
        return acctServerInstance.get(`/prod/uni2/public/get203return?dateend=${end_time}&datestart=${start_time}&warehouse=${warehouse}`)
            .then(({data}) => {
                dispatch({
                    type: GET_DELIVER_RETURN_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_DELIVER_RETURN_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getLastStateStatistics(start_time, end_time, warehouse, state){
    return function(dispatch){
        dispatch({type: GET_LAST_STATE_STATISTICS})
        return adminServerInstance.get(`/business/getlaststatestatistics?start=${start_time}&end=${end_time}&warehouse=${warehouse}&laststate=${state}`)
            .then(({data}) => {
                dispatch({
                    type: GET_LAST_STATE_STATISTICS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_LAST_STATE_STATISTICS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getWrongRouteOrders(start_time, end_time, warehouse){
    return function(dispatch){
        dispatch({type: GET_WRONG_ROUTE_ORDERS})
        return adminServerInstance.get(`/business/getwrongroutestatistics`, {
            params: {
                start: start_time,
                end: end_time,
                warehouse: warehouse
            }
        })
            .then(({data}) => {
                dispatch({
                    type: GET_WRONG_ROUTE_ORDERS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: GET_WRONG_ROUTE_ORDERS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}